import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";

export interface TabContainerProps {
  children: any;
  className?: string;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      borderBottom: `6px solid ${theme.palette.info.dark}`
    }
  }),
  { name: "TabContainer" }
);

const TabContainer = (props: TabContainerProps) => {
  const { children, className } = props;

  const classes = useStyles(props);

  return <div className={classNames(classes.root, className)}>{children}</div>;
};
TabContainer.displayName = "TabContainer";

export default TabContainer;
